import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import SearchInput from "../../../../../../../components-new/form/SearchInput";
import DestructiveButton from "../../../../../../../components-new/buttons/DestructiveButton";
import DeleteIcon from "../../../../../../../assets/icons/DeleteIcon";
import Translate from "../../../../../../../components/Translate";

const MembersTableToolbar = (props) => {
    const {
        numSelected,
        handleSearch, searchString, removeMembers,
    } = props;

    return (
        <div style={{marginBottom: '16px'}}>
            <h2 style={{flex: '0 0 auto'}}/>
            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                <div style={{width: '300px'}}>
                    <SearchInput
                        value={searchString}
                        onChange={e => handleSearch(e.target.value)}
                        id="members-search-input"
                        style={{height:'36px'}}
                    />
                </div>
                {numSelected > 0 && (
                    <DestructiveButton
                        variant="outline"
                        size="sm"
                        width="auto"
                        type="button"
                        onClick={() => removeMembers()}
                    >
                        <DeleteIcon width={18} height={18} stroke="currentColor"/>
                        <Translate text="removeUsers"/>
                    </DestructiveButton>
                )}
            </div>
        </div>
    );
};

MembersTableToolbar.propTypes = {
    user: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    searchString: PropTypes.string.isRequired,
    handleSearch: PropTypes.func.isRequired,
    removeMembers: PropTypes.func.isRequired,
};

export default Radium(MembersTableToolbar);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/EmployeesTable/partials/MembersTableToolbar.jsx